import { hasRole, useAuth } from "@/lib/auth";

export function AccessDenied() {
  return (
    <section
      role="alert"
      data-testid="access-denied"
      className="min-h-[50vh] grid place-items-center px-6"
    >
      <div className="max-w-lg border border-destructive/30 bg-card p-8 text-center shadow-sm">
        <p className="text-[11px] font-bold tracking-[0.25em] uppercase text-destructive">Access Denied</p>
        <h1 className="mt-3 font-display text-2xl font-extrabold">Admin access required</h1>
        <p className="mt-3 text-sm text-foreground/65">
          Access Denied: You do not have permission to view this page.
        </p>
      </div>
    </section>
  );
}

export default function RequireRole({ minRole, children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div data-testid="role-guard-loading" className="flex min-h-[50vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!hasRole(user, minRole)) return <AccessDenied />;

  return children;
}
